import appLogin from "../../views/login.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "login";
  const params = ["back"];

  $stateProvider.state("login", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appLogin,
      },
    },
    data: { title: "Login" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/login/login.urls.js